/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MobilePaymentRequest,
  PublicContract,
  PublicInvoice,
  PublicOnlineFallback,
  PublicOnlinePayment,
  PublicOnlineSimulateRequest,
  PublicOnlineSimulated,
  PublicOnlineStart,
  PublicOnlineStartRequest,
  PublicOnlineUnavailable,
  PublicPayResult,
  PublicPayRetrieveParams,
  PublicRestoreAlertCreated,
  PublicRestoreAlertRequest,
  PublicSignRequest,
  PublicSignResult
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The client reads the contract, receives a code on WhatsApp and signs (no account needed).
 */
export type publicContractsRetrieveResponse200 = {
  data: PublicContract
  status: 200
}
    
export type publicContractsRetrieveResponseSuccess = (publicContractsRetrieveResponse200) & {
  headers: Headers;
};
;

export type publicContractsRetrieveResponse = (publicContractsRetrieveResponseSuccess)

export const getPublicContractsRetrieveUrl = (token: string,) => {


  

  return `/api/v1/public/contracts/${token}/`
}

export const publicContractsRetrieve = async (token: string, options?: RequestInit): Promise<publicContractsRetrieveResponse> => {
  
  return apiFetch<publicContractsRetrieveResponse>(getPublicContractsRetrieveUrl(token),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPublicContractsRetrieveQueryKey = (token?: string,) => {
    return [
    `/api/v1/public/contracts/${token}/`
    ] as const;
    }

    
export const getPublicContractsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof publicContractsRetrieve>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicContractsRetrieveQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicContractsRetrieve>>> = ({ signal }) => publicContractsRetrieve(token, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicContractsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof publicContractsRetrieve>>>
export type PublicContractsRetrieveQueryError = unknown


export function usePublicContractsRetrieve<TData = Awaited<ReturnType<typeof publicContractsRetrieve>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicContractsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicContractsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicContractsRetrieve<TData = Awaited<ReturnType<typeof publicContractsRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicContractsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicContractsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicContractsRetrieve<TData = Awaited<ReturnType<typeof publicContractsRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicContractsRetrieve<TData = Awaited<ReturnType<typeof publicContractsRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicContractsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicContractsRetrieveQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Without a code: sends one. With a code: signs.
 */
export type publicContractsCreateResponse200 = {
  data: PublicSignResult
  status: 200
}
    
export type publicContractsCreateResponseSuccess = (publicContractsCreateResponse200) & {
  headers: Headers;
};
;

export type publicContractsCreateResponse = (publicContractsCreateResponseSuccess)

export const getPublicContractsCreateUrl = (token: string,) => {


  

  return `/api/v1/public/contracts/${token}/`
}

export const publicContractsCreate = async (token: string,
    publicSignRequest: PublicSignRequest, options?: RequestInit): Promise<publicContractsCreateResponse> => {
  
  return apiFetch<publicContractsCreateResponse>(getPublicContractsCreateUrl(token),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicSignRequest,)
  }
);}




export const getPublicContractsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicContractsCreate>>, TError,{token: string;data: PublicSignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicContractsCreate>>, TError,{token: string;data: PublicSignRequest}, TContext> => {

const mutationKey = ['publicContractsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicContractsCreate>>, {token: string;data: PublicSignRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  publicContractsCreate(token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublicContractsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicContractsCreate>>>
    export type PublicContractsCreateMutationBody = PublicSignRequest
    export type PublicContractsCreateMutationError = unknown

    export const usePublicContractsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicContractsCreate>>, TError,{token: string;data: PublicSignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicContractsCreate>>,
        TError,
        {token: string;data: PublicSignRequest},
        TContext
      > => {

      const mutationOptions = getPublicContractsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A payment link the client can share with whoever pays (parent, sponsor abroad, P2-08).
 */
export type publicPayRetrieveResponse200 = {
  data: PublicInvoice
  status: 200
}
    
export type publicPayRetrieveResponseSuccess = (publicPayRetrieveResponse200) & {
  headers: Headers;
};
;

export type publicPayRetrieveResponse = (publicPayRetrieveResponseSuccess)

export const getPublicPayRetrieveUrl = (token: string,
    params?: PublicPayRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/public/pay/${token}/?${stringifiedParams}` : `/api/v1/public/pay/${token}/`
}

export const publicPayRetrieve = async (token: string,
    params?: PublicPayRetrieveParams, options?: RequestInit): Promise<publicPayRetrieveResponse> => {
  
  return apiFetch<publicPayRetrieveResponse>(getPublicPayRetrieveUrl(token,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPublicPayRetrieveQueryKey = (token?: string,
    params?: PublicPayRetrieveParams,) => {
    return [
    `/api/v1/public/pay/${token}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPublicPayRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof publicPayRetrieve>>, TError = unknown>(token: string,
    params?: PublicPayRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicPayRetrieveQueryKey(token,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicPayRetrieve>>> = ({ signal }) => publicPayRetrieve(token,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicPayRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof publicPayRetrieve>>>
export type PublicPayRetrieveQueryError = unknown


export function usePublicPayRetrieve<TData = Awaited<ReturnType<typeof publicPayRetrieve>>, TError = unknown>(
 token: string,
    params: undefined |  PublicPayRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicPayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicPayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicPayRetrieve<TData = Awaited<ReturnType<typeof publicPayRetrieve>>, TError = unknown>(
 token: string,
    params?: PublicPayRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicPayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicPayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicPayRetrieve<TData = Awaited<ReturnType<typeof publicPayRetrieve>>, TError = unknown>(
 token: string,
    params?: PublicPayRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicPayRetrieve<TData = Awaited<ReturnType<typeof publicPayRetrieve>>, TError = unknown>(
 token: string,
    params?: PublicPayRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicPayRetrieveQueryOptions(token,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A payment link the client can share with whoever pays (parent, sponsor abroad, P2-08).
 */
export type publicPayCreateResponse201 = {
  data: PublicPayResult
  status: 201
}
    
export type publicPayCreateResponseSuccess = (publicPayCreateResponse201) & {
  headers: Headers;
};
;

export type publicPayCreateResponse = (publicPayCreateResponseSuccess)

export const getPublicPayCreateUrl = (token: string,) => {


  

  return `/api/v1/public/pay/${token}/`
}

export const publicPayCreate = async (token: string,
    mobilePaymentRequest: MobilePaymentRequest, options?: RequestInit): Promise<publicPayCreateResponse> => {
  
  return apiFetch<publicPayCreateResponse>(getPublicPayCreateUrl(token),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mobilePaymentRequest,)
  }
);}




export const getPublicPayCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayCreate>>, TError,{token: string;data: MobilePaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicPayCreate>>, TError,{token: string;data: MobilePaymentRequest}, TContext> => {

const mutationKey = ['publicPayCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicPayCreate>>, {token: string;data: MobilePaymentRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  publicPayCreate(token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublicPayCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicPayCreate>>>
    export type PublicPayCreateMutationBody = MobilePaymentRequest
    export type PublicPayCreateMutationError = unknown

    export const usePublicPayCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayCreate>>, TError,{token: string;data: MobilePaymentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicPayCreate>>,
        TError,
        {token: string;data: MobilePaymentRequest},
        TContext
      > => {

      const mutationOptions = getPublicPayCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * An online payment for (part of) the balance: returns the hosted page to open.
 */
export type publicPayOnlineCreateResponse201 = {
  data: PublicOnlineStart
  status: 201
}

export type publicPayOnlineCreateResponse409 = {
  data: PublicOnlineFallback
  status: 409
}

export type publicPayOnlineCreateResponse503 = {
  data: PublicOnlineUnavailable
  status: 503
}
    
export type publicPayOnlineCreateResponseSuccess = (publicPayOnlineCreateResponse201) & {
  headers: Headers;
};
export type publicPayOnlineCreateResponseError = (publicPayOnlineCreateResponse409 | publicPayOnlineCreateResponse503) & {
  headers: Headers;
};

export type publicPayOnlineCreateResponse = (publicPayOnlineCreateResponseSuccess | publicPayOnlineCreateResponseError)

export const getPublicPayOnlineCreateUrl = (token: string,) => {


  

  return `/api/v1/public/pay/${token}/online/`
}

export const publicPayOnlineCreate = async (token: string,
    publicOnlineStartRequest: PublicOnlineStartRequest, options?: RequestInit): Promise<publicPayOnlineCreateResponse> => {
  
  return apiFetch<publicPayOnlineCreateResponse>(getPublicPayOnlineCreateUrl(token),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicOnlineStartRequest,)
  }
);}




export const getPublicPayOnlineCreateMutationOptions = <TError = PublicOnlineFallback | PublicOnlineUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineCreate>>, TError,{token: string;data: PublicOnlineStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineCreate>>, TError,{token: string;data: PublicOnlineStartRequest}, TContext> => {

const mutationKey = ['publicPayOnlineCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicPayOnlineCreate>>, {token: string;data: PublicOnlineStartRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  publicPayOnlineCreate(token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublicPayOnlineCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicPayOnlineCreate>>>
    export type PublicPayOnlineCreateMutationBody = PublicOnlineStartRequest
    export type PublicPayOnlineCreateMutationError = PublicOnlineFallback | PublicOnlineUnavailable

    export const usePublicPayOnlineCreate = <TError = PublicOnlineFallback | PublicOnlineUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineCreate>>, TError,{token: string;data: PublicOnlineStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicPayOnlineCreate>>,
        TError,
        {token: string;data: PublicOnlineStartRequest},
        TContext
      > => {

      const mutationOptions = getPublicPayOnlineCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type publicPayOnlineRetrieveResponse200 = {
  data: PublicOnlinePayment
  status: 200
}
    
export type publicPayOnlineRetrieveResponseSuccess = (publicPayOnlineRetrieveResponse200) & {
  headers: Headers;
};
;

export type publicPayOnlineRetrieveResponse = (publicPayOnlineRetrieveResponseSuccess)

export const getPublicPayOnlineRetrieveUrl = (token: string,
    paymentId: string,) => {


  

  return `/api/v1/public/pay/${token}/online/${paymentId}/`
}

export const publicPayOnlineRetrieve = async (token: string,
    paymentId: string, options?: RequestInit): Promise<publicPayOnlineRetrieveResponse> => {
  
  return apiFetch<publicPayOnlineRetrieveResponse>(getPublicPayOnlineRetrieveUrl(token,paymentId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPublicPayOnlineRetrieveQueryKey = (token?: string,
    paymentId?: string,) => {
    return [
    `/api/v1/public/pay/${token}/online/${paymentId}/`
    ] as const;
    }

    
export const getPublicPayOnlineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError = unknown>(token: string,
    paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicPayOnlineRetrieveQueryKey(token,paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>> = ({ signal }) => publicPayOnlineRetrieve(token,paymentId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(token && paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicPayOnlineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>>
export type PublicPayOnlineRetrieveQueryError = unknown


export function usePublicPayOnlineRetrieve<TData = Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError = unknown>(
 token: string,
    paymentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicPayOnlineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicPayOnlineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicPayOnlineRetrieve<TData = Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError = unknown>(
 token: string,
    paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicPayOnlineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicPayOnlineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicPayOnlineRetrieve<TData = Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError = unknown>(
 token: string,
    paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicPayOnlineRetrieve<TData = Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError = unknown>(
 token: string,
    paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicPayOnlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicPayOnlineRetrieveQueryOptions(token,paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Local simulator only (test mode without a key): plays the provider's answer, no money.
 */
export type publicPayOnlineSimulateCreateResponse202 = {
  data: PublicOnlineSimulated
  status: 202
}
    
export type publicPayOnlineSimulateCreateResponseSuccess = (publicPayOnlineSimulateCreateResponse202) & {
  headers: Headers;
};
;

export type publicPayOnlineSimulateCreateResponse = (publicPayOnlineSimulateCreateResponseSuccess)

export const getPublicPayOnlineSimulateCreateUrl = (token: string,
    paymentId: string,) => {


  

  return `/api/v1/public/pay/${token}/online/${paymentId}/simulate/`
}

export const publicPayOnlineSimulateCreate = async (token: string,
    paymentId: string,
    publicOnlineSimulateRequest: PublicOnlineSimulateRequest, options?: RequestInit): Promise<publicPayOnlineSimulateCreateResponse> => {
  
  return apiFetch<publicPayOnlineSimulateCreateResponse>(getPublicPayOnlineSimulateCreateUrl(token,paymentId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicOnlineSimulateRequest,)
  }
);}




export const getPublicPayOnlineSimulateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>, TError,{token: string;paymentId: string;data: PublicOnlineSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>, TError,{token: string;paymentId: string;data: PublicOnlineSimulateRequest}, TContext> => {

const mutationKey = ['publicPayOnlineSimulateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>, {token: string;paymentId: string;data: PublicOnlineSimulateRequest}> = (props) => {
          const {token,paymentId,data} = props ?? {};

          return  publicPayOnlineSimulateCreate(token,paymentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublicPayOnlineSimulateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>>
    export type PublicPayOnlineSimulateCreateMutationBody = PublicOnlineSimulateRequest
    export type PublicPayOnlineSimulateCreateMutationError = unknown

    export const usePublicPayOnlineSimulateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>, TError,{token: string;paymentId: string;data: PublicOnlineSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicPayOnlineSimulateCreate>>,
        TError,
        {token: string;paymentId: string;data: PublicOnlineSimulateRequest},
        TContext
      > => {

      const mutationOptions = getPublicPayOnlineSimulateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-132: « tell me by e-mail when online payment works again » on the invoice link.
 */
export type publicPayOnlineNotifyRestoredCreateResponse201 = {
  data: PublicRestoreAlertCreated
  status: 201
}
    
export type publicPayOnlineNotifyRestoredCreateResponseSuccess = (publicPayOnlineNotifyRestoredCreateResponse201) & {
  headers: Headers;
};
;

export type publicPayOnlineNotifyRestoredCreateResponse = (publicPayOnlineNotifyRestoredCreateResponseSuccess)

export const getPublicPayOnlineNotifyRestoredCreateUrl = (token: string,) => {


  

  return `/api/v1/public/pay/${token}/online/notify-restored/`
}

export const publicPayOnlineNotifyRestoredCreate = async (token: string,
    publicRestoreAlertRequest: PublicRestoreAlertRequest, options?: RequestInit): Promise<publicPayOnlineNotifyRestoredCreateResponse> => {
  
  return apiFetch<publicPayOnlineNotifyRestoredCreateResponse>(getPublicPayOnlineNotifyRestoredCreateUrl(token),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publicRestoreAlertRequest,)
  }
);}




export const getPublicPayOnlineNotifyRestoredCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>, TError,{token: string;data: PublicRestoreAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>, TError,{token: string;data: PublicRestoreAlertRequest}, TContext> => {

const mutationKey = ['publicPayOnlineNotifyRestoredCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>, {token: string;data: PublicRestoreAlertRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  publicPayOnlineNotifyRestoredCreate(token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublicPayOnlineNotifyRestoredCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>>
    export type PublicPayOnlineNotifyRestoredCreateMutationBody = PublicRestoreAlertRequest
    export type PublicPayOnlineNotifyRestoredCreateMutationError = unknown

    export const usePublicPayOnlineNotifyRestoredCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>, TError,{token: string;data: PublicRestoreAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicPayOnlineNotifyRestoredCreate>>,
        TError,
        {token: string;data: PublicRestoreAlertRequest},
        TContext
      > => {

      const mutationOptions = getPublicPayOnlineNotifyRestoredCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    